import {History} from '../../../graphql-typings/graphql';
import {FunctionName} from './chart-function-types';
import {AbstractFunction} from './abstract-function';

export abstract class PeriodFunction extends AbstractFunction {

  protected constructor(name: FunctionName, longNameKey: string) {
    super(name, longNameKey);
  }

  protected applyPeriodFunction(historyArray: History[], f: (ha: History[]) => number, padValues?: boolean): History[] {
    if (historyArray && historyArray.length) {
      const value = f(historyArray);
      return padValues
        ? historyArray.map(h => Object.assign({}, h, {data: value}))
        : [Object.assign({}, historyArray[0], {data: value})];
    } else {
      return [];
    }
  }
}
